import React from "react";
import { createRoot } from "react-dom/client";

import LeadForm from "@/Module/LeadCaptureForm/LeadForm";

const domContainer = document.querySelector("#leadform");
if (domContainer) {
  const root = createRoot(domContainer);
  root.render(<LeadForm />);
}
